import { app, db, functions } from '..';
import {
  sendStageEnd,
  sendStageScore,
  sendStageStart,
} from '@riddler-co-jp/specc-auth-client';
import { DocumentReference, doc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import {
  DocumentDataHook,
  useDocumentData,
} from 'react-firebase-hooks/firestore';

export type Game3 = {
  answers: (number | null)[];
  totalScore: number;
};
export type Stats = {
  rate: number[];
  averageScore: number;
};

type Maybe<T> = T | null;

const stageId = 'ct2create';

export const startGame3 = (eventId: string, uid: string) =>
  sendStageStart(app, eventId, uid, stageId);

export const submitGame3 = (eventId: string, uid: string, result: Game3) => {
  const recordSubmissions = httpsCallable(functions, 'recordSubmissions');
  return Promise.allSettled([
    recordSubmissions({ eventId, result }),
    sendStageScore(app, eventId, uid, stageId, result.totalScore),
  ]);
};

export const finishGame3 = (eventId: string, uid: string) =>
  sendStageEnd(app, eventId, uid, stageId);

export const useStage3SubmissionDocData = (
  eventId?: Maybe<string>,
  userId?: Maybe<string>
): DocumentDataHook<Game3> => {
  const docRef =
    eventId != null && userId != null
      ? (doc(
          db,
          'version/1/submissions',
          eventId,
          'users',
          userId
        ) as DocumentReference<Game3>)
      : undefined;
  return useDocumentData<Game3>(docRef);
};

export const useStatDocData = (
  eventId?: Maybe<string>
): DocumentDataHook<Stats> => {
  const docRef =
    eventId != null
      ? (doc(db, 'version/1/stats', eventId) as DocumentReference<Stats>)
      : undefined;
  return useDocumentData<Stats>(docRef);
};
